/* @flow */

import { FlatList } from 'react-native'
import listenToKeyboardEvents from './KeyboardAwareHOC'

export default listenToKeyboardEvents(FlatList)



// WEBPACK FOOTER //
// ./node_modules/react-native-keyboard-aware-scroll-view/lib/KeyboardAwareFlatList.js